import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import courseDefault from '../../assets/course.jpg';


export default function Category() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);
    const [category, setCategory] = useState(null);


    useEffect(() => {
        init()
    }, [id]);

    
    async function init() {
        var responseCategory = await DataManager.getItem('category', id)
        if(responseCategory.success === 1) {
            if(responseCategory.body.length) {
                setCategory(responseCategory.body[0])
            }
            else {
                setCategory({
                    name: 'Categoria non trovata',
                    description: 'Questa categoria non esiste.'
                })
            }
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(responseCategory)
        }


        let constraints = [
            {
                "fieldName": "idCategory",
                "type": "value",
                "value": id
            }
        ]
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var response = await DataManager.searchItems('course', 1, 1000, sorting, '', [], constraints)
        if(response.success === 1) {
            var t = response.body
            setData(t)
            console.warn('courses', t)
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
    }


    function openCourse(item) {
        navigate('/course/' + item.id)
    }



    if (category) {
        return (
            <>
                <Helmet>
                    <title>{category.name}</title>
                </Helmet>

                <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                    <h3 className='text-center'>{category.name}</h3>
                    <p className='text-center m-auto' style={{maxWidth:600}}>{category.description}</p>

                    {errors.length > 0 &&
                        <Alert variant='danger'>
                            {errors}
                        </Alert>
                    }

                    {data && data.length > 0 ? ( 
                        <Row className='mt-5 mb-5'>
                            {data.map((item, j) => {
                                var image = item.image ? ResourceManager.getFileUrl(item.image, 'course') : courseDefault
                                return (
                                    <Col xs={12} md={6} lg={4} key={j}>
                                        <Card role="button" onClick={() => openCourse(item)} bg="dark" className='mt-3 mb-3 text-light course-grid-parent' style={{"backgroundImage": `url('${image}')`}}>
                                            <Card.Body className='course-grid-item'>
                                                <p>
                                                    <b>{item.name}</b>
                                                </p>
                                                <p>
                                                    <span className='small'>
                                                        {item.description && (
                                                            <>
                                                                <div dangerouslySetInnerHTML={{__html: item.description.length > 160 ? item.description.substring(0, 160) + '...' : item.description}}></div>
                                                            </> 
                                                        )}
                                                    </span>
                                                </p>
                                            </Card.Body>
                                        </Card>
                                        
                                    </Col>
                                )
                            })}
                        </Row>
                    ) : (
                        <></>
                    )}

                </Container>
            </>
        )
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};